
import * as React from 'react';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { LinkPrimaryButton, OverflowDropdownButton } from '../../uiComponents/input/Buttons';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { Button, DropdownButtonItem, DropdownButtonItemCallback } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import Table from '../../uiComponents/table/Table';
import { TableHeaderColumn } from 'react-bootstrap-table';
import TableFormatters from '../../uiComponents/table/TableFormatters';
import { Loading } from '../../uiComponents/Loading';
import { ValidationResult } from '../../infrastructure/ValidationResult';
import NotificationModule from '../../uiComponents/layout/Notification';
import { OpgaveListItem } from '../../models/OpgaveListItem';
import { Modal } from '../../uiComponents/layout/Modal';

interface OpgaveListProps {
}

interface OpgaveListState {
    opgaver?: OpgaveListItem[];
    isSubmitting: boolean;
    opgaveTilSletningId: string;
    opgaveTilAktiveringId: string;
    showInaktive: boolean;
}

class OpgaveList extends React.Component<OpgaveListProps, OpgaveListState> {
    constructor(props: OpgaveListProps) {
        super(props);

        this.copyOpgave = this.copyOpgave.bind(this);
        this.menuFormatter = this.menuFormatter.bind(this);
        this.state = { opgaver: undefined, isSubmitting: false, opgaveTilSletningId: '', opgaveTilAktiveringId: '', showInaktive: false };
    }

    componentDidMount() {
        this.getOpgaveList();
    }

    copyOpgave(id: string) {
        var self = this;
        if (!this.state.isSubmitting) {
            self.setState({ isSubmitting: true });
            createApiCaller().copyOpgave(id)
                .then(function (response: ValidationResult) {
                    if (response.isValid) {
                        self.getOpgaveList();
                        NotificationModule.showSuccess('', 'Opgaven blev kopiret', true);
                        self.setState({ isSubmitting: false });
                    }
                })
                .catch(() => self.setState({ isSubmitting: false }));
        }
    }

    sletOpgave(id: string) {
        this.setState({ opgaveTilSletningId: '' });
        createApiCaller().deleteOpgave(id)
            .then((response) => {
                response.json().then((jsonResponse: any) => {
                    if (jsonResponse.opgaveSlettet) {
                        NotificationModule.showSuccess('', 'Opgave blev slettet', true);
                    } else {
                        NotificationModule.showSuccess('', 'Opgaven blev inaktiveret', true);
                    }
                    this.getOpgaveList();
                });            
            });
    }

    aktiverOpgave(id: string) {
        this.setState({ opgaveTilAktiveringId: '' });
        createApiCaller().aktiverOpgave(id)
            .then((response) => {
                if (response.isValid) {
                    NotificationModule.showSuccess('', 'Opgaven blev aktiveret', true);
                    this.getOpgaveList();
                } else {
                    NotificationModule.showError('', 'Opgaven kunne ikke aktiveres', true);
                }
            });
    }

    setOpgaveTilSletning(id: string) {
        $('#sletOpgaveModal').modal();
        this.setState({ opgaveTilSletningId: id });
    }

    setOpgaveTilAktivering(id: string) {
        $('#aktiverOpgaveModal').modal();
        this.setState({ opgaveTilAktiveringId: id });
    }

    getOpgaveList() {
        var self = this;
        var result = createApiCaller().getOpaveListItems();
        result.then(function (json: any) {
            self.setState({ opgaver: json });
        });
    }

    getOpgaveSletAktiverDropdown(row: any) {
        if (row.aktiv) {
            return (<DropdownButtonItemCallback onClick={() => this.setOpgaveTilSletning(row.id)} text='Inaktivér/slet' />);
        }

        return (<DropdownButtonItemCallback onClick={() => this.setOpgaveTilAktivering(row.id)} text='Aktivér' />);
    }

    menuFormatter(cell: any, row: any) {
        let editLink = '/opgave/rediger/' + row.id;

        return (
            <OverflowDropdownButton>
                <DropdownButtonItem href={'/opgave/preview/' + row.id} text='Forhåndsvisning' />
                <DropdownButtonItem href={editLink} text='Redigér' />
                <DropdownButtonItemCallback onClick={() => this.copyOpgave(row.id)} text='Kopier opgave' />
                {this.getOpgaveSletAktiverDropdown(row)}
            </OverflowDropdownButton>
        );
    }

    getSletOpgaveModal = () => {
        return (
            <Modal title='Er du sikker på, at du vil inaktivere/slette opgaven?' modalSize='lg' id='sletOpgaveModal' alert={true} excludeCancel={true} text='Hvis opgaven er tilknyttet en opgavepakke, vil opgaven blive inaktiveret - den inaktive opgave kan ikke tilføjes til opgavepakker efterfølgende. Såfremt opgaven ikke er tilknyttet en opgavepakke, slettes opgaven og kan ikke gendannes.' >
                <Button dataDismiss='modal' buttonType='primary' onClick={() => this.sletOpgave(this.state.opgaveTilSletningId)}>Inaktivér/slet</Button>
            </Modal>
        );
    }

    getAktiverOpgaveModal = () => {
        return (
            <Modal id='aktiverOpgaveModal' alert={true} excludeCancel={true} text='Ønsker du at aktivére denne opgave?' >
                <Button dataDismiss='modal' buttonType='primary' onClick={() => this.aktiverOpgave(this.state.opgaveTilAktiveringId)}>Aktivér</Button>
            </Modal>
        );
    }

    toogleVisInaktiveOpgaver = (checkboxEvent: any) => {
        if (checkboxEvent.target.checked) {
            this.setState({ showInaktive: true });
        } else {
            this.setState({ showInaktive: false });
        }
    }

    render() {
        let buttons = (
            <div>
                <label id='inaktiveOpgaverLabel' htmlFor='inaktiveCheckbox'>Vis inaktive opgaver</label>
                <input onClick={(e) => this.toogleVisInaktiveOpgaver(e)} id='inaktiveOpgaverCheckbox' type='checkbox' />
                <LinkPrimaryButton url={'/opgave/ny'} text={'Ny opgave'} />
            </div>);

        let opgaver = this.state.opgaver === undefined ? [] : this.state.opgaver;

        if (!this.state.showInaktive) {
            opgaver = opgaver.filter(o => o.aktiv);
        }

        return (
            <PageWrapper>
                <PageTitle title='Opgaver' />
                <ContentWrapper>
                    <Loading isLoading={this.state.opgaver === undefined}>
                        <SectionGroup header={opgaver.length + ' opgaver'} buttons={buttons}>
                            <Section fullWidth={true}>
                                <Table data={opgaver} pagination={true} emptyText='Ingen opgaver'>
                                    <TableHeaderColumn dataField='id' isKey={true} hidden={true} dataAlign='center' />
                                    <TableHeaderColumn
                                        dataField='createdDate'
                                        className='first'
                                        columnClassName='first'
                                        dataFormat={TableFormatters.dateFormatter}
                                        dataSort={true}
                                    >
                                        Oprettet
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField='titel' dataSort={true}>Titel på opgave</TableHeaderColumn>
                                    <TableHeaderColumn dataField='lastChangedDate' dataFormat={TableFormatters.dateDaysFormatter} dataSort={true}>Sidst opdateret</TableHeaderColumn>
                                    <TableHeaderColumn dataField='aktiv' dataFormat={TableFormatters.booleanFormatter} dataSort={true}>Aktiv</TableHeaderColumn>
                                    <TableHeaderColumn width='60' dataFormat={this.menuFormatter} className='table-menu' columnClassName='table-menu' />
                                </Table>
                            </Section>
                        </SectionGroup>
                    </Loading>
                </ContentWrapper>
                {this.getSletOpgaveModal()}
                {this.getAktiverOpgaveModal()}
            </PageWrapper>
        );
    }
}

export default OpgaveList;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgave/OpgaveList.tsx